/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pos_Delivery_Need_CustomerInputs */

const vi_pos_delivery_need_customer = /** @type {(inputs: Pos_Delivery_Need_CustomerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chọn khách hàng để tạo đơn giao`)
};

/**

* @param {Pos_Delivery_Need_CustomerInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pos_delivery_need_customer = /** @type {((inputs?: Pos_Delivery_Need_CustomerInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pos_Delivery_Need_CustomerInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pos_delivery_need_customer(inputs)
});